var _radialGradient, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Fr~bqA9iZI6v1mPZVXxEWa",
    cx: 24,
    cy: 560.111,
    r: 32.253,
    gradientTransform: "matrix(1 0 0 -1 0 570.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c9eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#889af8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#7e8fe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b8ce1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Fr~bqA9iZI6v1mPZVXxEWa)",
    d: "M40.107,12.15c-0.065-0.102-0.139-0.182-0.236-0.255c-0.355-0.267-5.744-3.889-9.865-3.889 c-0.258,0-0.825,1.1-1.016,1.987c-1.994,0.002-7.996-0.003-9.993,0.006c-0.236-0.838-0.844-1.99-1.008-1.99 c-4.122,0-9.487,3.606-9.861,3.887c-0.097,0.073-0.17,0.153-0.236,0.255c-0.708,1.107-5.049,8.388-5.892,21.632 c-0.009,0.142,0.04,0.289,0.135,0.395C6.728,39.321,13.318,39.929,14.724,40c0.167,0.008,0.335-0.059,0.427-0.199l1.099-1.665 l-3.246-1.54v-1.609c6.329,2.817,15.356,3.104,21.993,0.017l0.027,1.588l-3.205,1.65l1.028,1.559c0.092,0.14,0.26,0.208,0.427,0.199 c1.407-0.072,7.996-0.679,12.588-5.823c0.095-0.106,0.144-0.253,0.135-0.395C45.156,20.538,40.815,13.257,40.107,12.15z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 26,
    opacity: 0.05,
    rx: 4.5,
    ry: 5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 26,
    opacity: 0.05,
    rx: 4,
    ry: 4.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 26,
    fill: "#fff",
    rx: 3.5,
    ry: 4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 26,
    opacity: 0.05,
    rx: 4.5,
    ry: 5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 26,
    opacity: 0.05,
    rx: 4,
    ry: 4.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 26,
    fill: "#fff",
    rx: 3.5,
    ry: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.30fdbb9eee227bb22becc7d0a841ed49.svg";
export { ForwardRef as ReactComponent };